import React from "react";
import { Link } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { PageHero } from "@/components/common";
import { useSEO } from "@/lib/useSEO";
import { Home as HomeIcon, ArrowRight, Compass } from "lucide-react";

export default function NotFound() {
  useSEO({ title: "Page Not Found | Atmasamman Group", description: "The page you're looking for may have moved or no longer exists.", path: "/404" });
  return (
    <Layout>
      <PageHero eyebrow="404" title="Page Not Found" subtitle="The page you're looking for may have moved or no longer exists.">
        <div className="flex flex-wrap gap-4">
          <Link to="/" data-testid="notfound-home" className="inline-flex items-center gap-2 rounded-xl bg-orange-500 px-6 py-3 text-sm font-semibold text-white transition-all hover:bg-orange-600 hover:-translate-y-0.5 md:text-base">
            <HomeIcon className="h-4 w-4" /> Back to Home
          </Link>
          <Link to="/organizations" data-testid="notfound-orgs" className="inline-flex items-center gap-2 rounded-xl border border-white/20 bg-white/5 px-6 py-3 text-sm font-semibold text-white transition-all hover:border-orange-500/50 md:text-base">
            <Compass className="h-4 w-4" /> Explore Our Organizations <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </PageHero>
    </Layout>
  );
}
